import React, { Fragment } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Main from '../pages/main/main';
import Toast from '../popup/toast/toast';
import history from './history';

const getRoutes = (form, sessionId) => {
  console.log('🟡 getRoutes: Creating routes with sessionId:', sessionId);
  return createBrowserRouter([
    {
      path: '/get-quote/:form',
      element: <Main form={null} sessionId={sessionId} />, // form comes from URL param
    },
    {
      path: '/:id',
      element: <Main form={form} sessionId={sessionId} />,
    },
    {
      path: '*',
      element: <Main form={form} sessionId={sessionId} />,
    },
  ]);
};

export const Router = ({ form, sessionId }) => {
  console.log('🟡 Router: Received sessionId:', sessionId);
  const router = getRoutes(form, sessionId);
  console.log('🟡 Router: Created routes with sessionId:', sessionId);
  return (
    <Fragment>
      <RouterProvider history={history} router={router} />
      <Toast />
    </Fragment>
  );
};
